import React from "react";
import AccessDeniedScreen from "../Screens/AccessDenied";
import MFARequiredScreen from "../Screens/MFARequired";
import AccountScreenContainer from "../Screens/Account/AccountScreenContainer";
import AdminScreenContainer from "../Screens/Admin/AdminScreenContainer";
import AnswererScreenContainer from "../Screens/Answerer/AnswererScreenContainer";
import BatchScreenContainer from "../Screens/Batch/BatchScreenContainer";
import DashboardScreenContainer from "../Screens/Dashboard/DashboardScreenContainer";
import DocumentsScreenContainer from "../Screens/Documents/DocumentsScreenContainer";
import GeneratorScreenContainer from "../Screens/Generator/GeneratorScreenContainer";
import MrcDocumentsContainer from "../Screens/MrcDocuments/MrcDocumentsContainer";
import PageNotFound from "../Screens/PageNotFound";
import SettingsScreenContainer from "../Screens/Settings/SettingsScreenContainer";
import TestAnExampleScreenContainer from "../Screens/TestExample/TestAnExampleScreenContainer";
import TrainingScreenContainer from "../Screens/Training/TrainingScreenContainer";
import WorkspacesScreenContainer from "../Screens/Workspaces/WorkspacesScreenContainer";
import ChatsScreenContainer from "../Screens/Chats/ChatsScreenContainer";
import HomeScreenContainer from "../Screens/Home/HomeScreenContainer";
import AgentBuilderScreenContainer from "../Screens/Agents/AgentBuilderScreenContainer";
import ToolBuilderScreenContainer from "../Screens/Tools/ToolBuilderScreenContainer";
import PromptBuilderScreenContainer from "../Screens/Prompts/PromptBuilderScreenContainer";
import HookBuilderScreenContainer from "../Screens/Hooks/HookBuilderScreenContainer";
import AuthorisationBuilderScreenContainer from "../Screens/Settings/Components/Authorisations/AuthorisationBuilderScreenContainer";
import JobBuilderScreenContainer from "../Screens/Settings/Components/Jobs/JobBuilderScreenContainer";
import AlertBuilderScreenContainer from "../Screens/Settings/Components/Alerts/AlertBuilderScreenContainer";
import TriggerBuilderScreenContainer from "../Screens/Settings/Components/Triggers/TriggerBuilderScreenContainer";
import SiteBuilderScreenContainer from "../Screens/Settings/Components/Sites/SiteBuilderScreenContainer";
import ConnectionBuilderScreenContainer from "../Screens/Settings/Components/Connections/ConnectionBuilderScreenContainer";
import HostingBuilderScreenContainer from "../Screens/Settings/Components/Hostings/HostingBuilderScreenContainer";
import ChannelBuilderScreenContainer from "../Screens/Settings/Components/Channels/ChannelBuilderScreenContainer";
import BenchmarkBuilderScreenContainer from "../Screens/Settings/Components/Benchmarks/BenchmarkBuilderScreenContainer";
import AdminRoute from "./AdminRoute";
import { Redirect, Route, Switch } from "./index";
import ProRoute from "./ProRoute";
import PowerUserRoute from "./PowerUserRoute";
import AIEngineerRoute from "./AIEngineerRoute";
import ContentCreatorRoute from "./ContentCreatorRoute";
import SentimentReviewerRoute from "./SentimentReviewerRoute";
import BusinessAnalystRoute from "./BusinessAnalystRoute";
import TFRoute from "./TFRoute";
import ErrorPage from "../Screens/ErrorPage";
import Controller from "../Screens/Arena/Controller";
import DashboardContainer from "../Screens/Arena/Dashboard/DashboardContainer";

export const routes = {
  home: "/workspaces/:workspaceId/home/:chatId?",
  dashboard: "/workspaces/:workspaceId/dashboard/:sectionId?",
  nlp: "/workspaces/:workspaceId/nlp/:documentId?",
  answerer: "/workspaces/:workspaceId/answerer/:documentId?",
  rc_training: "/workspaces/:workspaceId/documents/rc/:documentId",
  gn_training: "/workspaces/:workspaceId/documents/:type/:documentId",
  documents: "/workspaces/:workspaceId/documents/:sectionId?",
  chats: "/workspaces/:workspaceId/chats/:chatId?",
  agents: "/workspaces/:workspaceId/agents/:agentId?/:chatId?",
  tools: "/workspaces/:workspaceId/tools/:toolId?",
  prompts: "/workspaces/:workspaceId/prompts/:promptId?",
  hooks: "/workspaces/:workspaceId/hooks/:hookId?",
  authorisations: "/workspaces/:workspaceId/authorisations/:authorisationId?",
  jobs: "/workspaces/:workspaceId/jobs/:jobId?",
  alerts: "/workspaces/:workspaceId/alerts/:alertId?",
  triggers: "/workspaces/:workspaceId/triggers/:triggerId?",
  sites: "/workspaces/:workspaceId/sites/:siteId?",
  connections: "/workspaces/:workspaceId/connections/:connectionId?",
  hostings: "/workspaces/:workspaceId/hostings/:hostingId?",
  channels: "/workspaces/:workspaceId/channels/:channelId?",
  benchmarks: "/workspaces/:workspaceId/benchmarks/:benchmarkId?",
  mrc_contents: "/workspaces/:workspaceId/mrc_contents/:documentId?",
  generator: "/workspaces/:workspaceId/generator/:documentId?",
  training: "/workspaces/:workspaceId/training/:sectionId?",
  batch: "/workspaces/:workspaceId/batch/:sectionId?",
  settings: "/workspaces/:workspaceId/settings/:sectionId?/:optId?",
  profile: "/profile/:sectionId?",
  workspaces: "/workspaces",
  admin: "/workspaces/:workspaceId/admin/:sectionId?",
  arena: "/workspaces/:workspaceId/arena/:sectionId?",
  arenaLeaderboard: "/workspaces/:workspaceId/arena_leaderboard",
  pagenotfound: "/pagenotfound",
  accessDenied: "/accessdenied",
  mfaRequired: "/mfa_required",
  landingPage: "/workspaces/:workspaceId",
  error: "/error",
};

const Routes = ({ currentView, setCurrentView }) => {
  return (
    <Switch>
      <SentimentReviewerRoute
        path={routes.nlp}
        exact
        component={TestAnExampleScreenContainer}
      />
      <BusinessAnalystRoute
        path={routes.answerer}
        exact
        component={AnswererScreenContainer}
      />
      {/* <Route
        path={routes.rc_training}
        exact
        component={AnswererScreenContainer}
      /> */}
      <Route
        path={routes.mrc_contents}
        exact
        component={MrcDocumentsContainer}
      />
      <ContentCreatorRoute
        path={routes.generator}
        exact
        component={GeneratorScreenContainer}
      />
      <Route
        path={routes.gn_training}
        exact
        component={GeneratorScreenContainer}
      />
      <AIEngineerRoute
        path={routes.documents}
        exact
        component={DocumentsScreenContainer}
      />
      <PowerUserRoute
        path={routes.agents}
        exact
        component={AgentBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.tools}
        exact
        component={ToolBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.prompts}
        exact
        component={PromptBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.hooks}
        exact
        component={HookBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.authorisations}
        exact
        component={AuthorisationBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.jobs}
        exact
        component={JobBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.alerts}
        exact
        component={AlertBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.triggers}
        exact
        component={TriggerBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.sites}
        exact
        component={SiteBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.connections}
        exact
        component={ConnectionBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.hostings}
        exact
        component={HostingBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.channels}
        exact
        component={ChannelBuilderScreenContainer}
      />
      <PowerUserRoute
        path={routes.benchmarks}
        exact
        component={BenchmarkBuilderScreenContainer}
      />
      <Route path={routes.chats} exact component={ChatsScreenContainer} />
      <Route path={routes.home} exact component={HomeScreenContainer} />

      <AIEngineerRoute
        path={routes.training}
        exact
        component={TrainingScreenContainer}
      />
      <ProRoute path={routes.batch} exact component={BatchScreenContainer} />
      <Route path={routes.profile} exact>
        <AccountScreenContainer setCurrentView={setCurrentView} />
      </Route>
      <Route
        path={routes.workspaces}
        exact
        component={WorkspacesScreenContainer}
      />
      <PowerUserRoute
        path={routes.settings}
        exact
        component={SettingsScreenContainer}
      />
      <Route exact path="/">
        {currentView !== "auth" && <Redirect to={routes.workspaces} />}
      </Route>
      <Route exact path="/signUp">
        {currentView !== "auth" && <Redirect to={routes.workspaces} />}
      </Route>
      <Route exact path="/google_signup">
        {currentView !== "auth" && <Redirect to={routes.workspaces} />}
      </Route>
      <Route exact path="/code_confirmation/:token?">
        {currentView !== "auth" && <Redirect to={routes.workspaces} />}
      </Route>
      <Route exact path="/fastSignup">
        {currentView !== "auth" && <Redirect to={routes.workspaces} />}
      </Route>
      <AdminRoute
        path={routes.dashboard}
        exact
        component={DashboardScreenContainer}
        isDashboard={true}
      />
      <AdminRoute path={routes.arena} exact component={Controller} />
      <AdminRoute
        path={routes.arenaLeaderboard}
        exact
        component={DashboardContainer}
      />
      {/* component={DashboardScreenContainer} */}
      {/* /> */}
      <Route path={routes.accessDenied} exact component={AccessDeniedScreen} />
      <Route path={routes.mfaRequired} exact component={MFARequiredScreen} />
      <AdminRoute path={routes.admin} exact component={AdminScreenContainer} />
      <Route path={routes.error} exact component={ErrorPage} />
      <TFRoute path={routes.landingPage} exact>
        {({ match }) => (
          <Redirect to={`/workspaces/${match?.params?.workspaceId}/home`} />
        )}
      </TFRoute>
      <Route component={PageNotFound} />
    </Switch>
  );
};

export default Routes;
